import OtherItems from './OtherItems';
import './OtherItems.scss';

export default OtherItems;